import LoggerMiddleware from './LoggerMiddleware';

const middleware = [LoggerMiddleware];

export { middleware as default, middleware };
